



































import TableExport from 'tableexport'
import TableDownloadButton from '@/elements/TableDownloadButton.vue'

export default {
  name: 'StatisticsTableFull'
  props: [
    'id'
    'label'
    'start'
    'end'
    'age_ranges'
    'cluster'
  ]

  components:
    'download-button': TableDownloadButton

  data: () ->
    table: {}

  methods:
    sumLengthByKey: (arr, key) ->
      sum = 0
      sum += (item[key] || []).length for item in arr
      sum

  mounted: ->
    @table = @$refs[@label]

}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/StatisticsTableFull.vue